var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9L3 6L9.03496 12L21 0L24 3L9 18L5.67761 14.8398L5.64373 14.7982L0 9Z",
    fill: "#00A84C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/Apply.2899a24d51b5d1faaef7becad93eccc4.svg";
export { ForwardRef as ReactComponent };